export class EdgeRouter {
    name = '';
    roleAttributes = [];
    appData = {};
    isTunnelerEnabled = true;
    noTraversal = false;
    cost = 0;
    tags = {};
};